import React, { Component } from 'react';
import {
    Modal, Button,
} from 'react-bootstrap';

class ContactUs extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false,
        };
    }

    closeModal = () => {
        this.setState({
            isModalOpen: false
        });
    }

    openModal = () => {
        this.setState({
            isModalOpen: true
        })
    }

    render() {
        return (
            <div>
                <Button variant="outline-secondary" onClick={this.openModal}>Contact Us</Button>
                <Modal show={this.state.isModalOpen} onHide={this.closeModal} size="lg">
                    <Modal.Header closeButton className="App-header">
                        <Modal.Title>Contact Us</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-5 text-center">
                        <h5>Have a suggestion or need to contact us? Here's our contact info: </h5>
                        <h5>Email: <b>support@edge.poker</b></h5>
                    </Modal.Body>
                    {/* <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeModal}>Close</Button>
                    </Modal.Footer> */}
                </Modal>
            </div>
        )
    }
}

export default ContactUs;